// FIXME: try using new use hook from React 19 for the context!!!

import type { Context } from "react";
import { useContext } from "react";

export const useContextAndErrorIfNull = <T>(context: Context<T>): NonNullable<T> => {
  const contextValue = useContext(context);

  if (contextValue == null) {
    throw Error("Context has not been Provided!");
  }

  return contextValue;
};
